var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"horizontal-text"},[_vm._v("核心产业信息：")]),_c('SelectTreeRadio',{attrs:{"isTree":true,"apiName":"getIndustryList","params":{
      groupLabelType: '赋能行业标签组',
      level: 4,
    },"resultType":"values","storageKey":"industryCategoryList","isRadioFirstLevel":false,"isCheckBoxButton":false},model:{value:(_vm.reportLabelList),callback:function ($$v) {_vm.reportLabelList=$$v},expression:"reportLabelList"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }